const NS = 'CapitalizeFilter';

export default function CapitalizeFilter() {
  return function (input) {
    return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
  };
}
